// // import { jwtDecode } from "jwt-decode";
// // import React, { useEffect, useState } from "react";
// // import { useSelector } from "react-redux";

// // import { Navigate, Outlet, useLocation } from "react-router-dom";

// // // const PrivateRoute = ({ element: Element, ...rest }) => {
// // const PrivateRoute = ({ children }) => {
// //   const [isAuth, setIsAuth] = useState(1);
// //   const location = useLocation();
// //   // const token = localStorage.getItem("Token");
// //   const userData = useSelector((state) => state.auth.user) || {};
// //   console.log("nav redux login Data:", userData);
// //   const token= userData?.token

// // console.log("Invoking private Route")
// //   useEffect(() => {
// //     verifyToken();
// //   }, []);

// //   console.log("isAuth", isAuth);
// //   const verifyToken = () => {
// //     if (!token) {
// //       setIsAuth(false);
// //       localStorage.setItem("isAuth", false);
// //     }
// //     try {
// //       const decodedToken = jwtDecode(token);
// //       const currentTime = Date.now() / 1000;
// //       if (decodedToken.exp < currentTime) {
// //         setIsAuth(false);
// //         localStorage.setItem("isAuth", false);
// //       } else {
// //         setIsAuth(true);
// //         localStorage.setItem("isAuth", true);
// //       }
// //     } catch (error) {
// //       setIsAuth(false);
// //       localStorage.setItem("isAuth", false);
// //       console.error("Error decoding token:", error);
// //     }
// //   };

// //   // return isAuth ? <Outlet /> : <Navigate to="/login" />;
// //   if (!isAuth) {
// //     return <Navigate to="/signIn" state={{ from: location }} />;
// //   }
// //   return children;
// // };

// // export default PrivateRoute;


// import React, { useEffect, useState } from "react";
// import { Navigate, Outlet, useLocation } from "react-router-dom";
// import { jwtDecode } from "jwt-decode";
// import axios from "axios";
// import { baseUrl } from "../config";
// import { useSelector } from "react-redux";



// const PrivateRoute = ({ children }) => {
//   const location = useLocation();
//   // This will give you something like '?token=abc123'
//   // const queryParams = new URLSearchParams(location.search);
//   const token = localStorage.getItem("Token");

//   const [status, setStatus] = useState({
//     loading: true,
//     isAuth: false,
//     isEmailVerified: false,
//     onboarded: false,
//     provider: null
//   });

//   // const userData = useSelector((state) => state.auth.user) || {};
//   // console.log("nav redux login Data:", userData);
//   // const token= userData?.token
//   // const token = userData?.token || queryParams.get("token");





//   const verifyTokenAndFetchUser = async () => {
//     if (!token) {
//       setStatus({ loading: false, isAuth: false });
//       return;
//     }

//     try {
//       const decoded = jwtDecode(token);
//       const currentTime = Date.now() / 1000;
//       if (decoded.exp < currentTime) {
//         // Token expired
//         setStatus({ loading: false, isAuth: false });
//         return;
//       }

//       // Token valid → Fetch user details
//       const userId = decoded.userId;
//       const response = await axios.get(`${baseUrl}/user/${userId}`, {
//         headers: { Authorization: `Bearer ${token}` }
//       });

//       console.log("response----", response.data);
//       const { isEmailVerified, onboarded, provider } = response.data;
//       setStatus({
//         loading: false,
//         isAuth: true,
//         isEmailVerified,
//         onboarded,
//         provider
//       });
//     } catch (error) {
//       console.error("Token/User fetch failed", error);
//       setStatus({ loading: false, isAuth: false });
//     }
//   };

//   useEffect(() => {
//     verifyTokenAndFetchUser();
//   }, []);


//   if (status.loading) return null; // or show spinner

//   // Redirect logic
//   if (!status.isAuth) {
//     console.log("User is not authenticated, redirecting to signIn");

//     return <Navigate to="/signIn" state={{ from: location }} />;
//   }

//   if (status.provider === "google" && location.pathname === "/verify-email") {
//     return <Navigate to="/" state={{ from: location }} />;
//   }

//   if (status.provider !== "google") {
//     if (!status.isEmailVerified && location.pathname !== "/verify-email") {
//       return <Navigate to="/verify-email" state={{ from: location }} />;
//     }
//   }



//   if (status.isEmailVerified && !status.onboarded && location.pathname !== "/onboarding") {
//     return <Navigate to="/onboarding" state={{ from: location }} />;
//   }

//   return children || <Outlet />;
// };

// export default PrivateRoute;


import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import { baseUrl } from "../config";

const PrivateRoute = ({ children }) => {
  const location = useLocation();
  const token = localStorage.getItem("Token");

  const [status, setStatus] = useState({
    loading: true,
    isAuth: false,
    isEmailVerified: false,
    onboarded: false,
    provider: null
  });

  const verifyTokenAndFetchUser = async () => {
    if (!token) {
      setStatus({ loading: false, isAuth: false });
      return;
    }

    try {
      const decoded = jwtDecode(token);
      const currentTime = Date.now() / 1000;

      if (decoded.exp < currentTime) {
        // Token expired
        setStatus({ loading: false, isAuth: false });
        return;
      }

      // Token valid → Fetch user details
      const userId = decoded.userId;
      const response = await axios.get(`${baseUrl}/user/${userId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      const { isEmailVerified: rawEmailVerified, onboarded, provider } = response.data;

      // Override: treat Google users as email verified
      const isEmailVerified = provider === "google" ? true : rawEmailVerified;

      setStatus({
        loading: false,
        isAuth: true,
        isEmailVerified,
        onboarded,
        provider
      });
    } catch (error) {
      console.error("Token/User fetch failed", error);
      setStatus({ loading: false, isAuth: false });
    }
  };

  useEffect(() => {
    verifyTokenAndFetchUser();
  }, []);

  if (status.loading) return null; // or show a spinner

  // Not authenticated → redirect to signIn
  if (!status.isAuth) {
    return <Navigate to="/signIn" state={{ from: location }} />;
  }

  // Block Google users from visiting /verify-email
  if (status.provider === "google" && location.pathname === "/verify-email") {
    const previousPath = location.state?.from?.pathname || "/";
    return <Navigate to={previousPath} replace />;
  }

  // Redirect email/password users to /verify-email if not verified
  if (!status.isEmailVerified && location.pathname !== "/verify-email") {
    return <Navigate to="/verify-email" state={{ from: location }} />;
  }

  // Redirect all verified users to onboarding if not yet onboarded
  if (status.isEmailVerified && !status.onboarded && location.pathname !== "/onboarding") {
    return <Navigate to="/onboarding" state={{ from: location }} />;
  }

  // Allow access
  return children || <Outlet />;
};

export default PrivateRoute;
